/* eslint-env browser */
'use strict';

var debug = require('debug');

var log = debug('jsipfs:preload');
log.error = debug('jsipfs:preload:error');

module.exports = function preload(url, callback) {
  log(url);
  var controller = new AbortController();
  var signal = controller.signal;
  fetch(url, {
    signal: signal
  }).then(function (res) {
    if (!res.ok) {
      log.error('failed to preload', url, res.status, res.statusText);
      throw new Error("failed to preload ".concat(url));
    }

    return res.text();
  }).then(function () {
    return callback();
  }).catch(callback);
  return {
    cancel: function cancel() {
      return controller.abort();
    }
  };
};